<div class="tree-node-content" [class.editable]="editable" (dblclick)="startEditing()" (contextmenu)="onContextMenu($event)" [title]="editable ? 'Dwuklik zmienia ilość' : ''">
  @if (depthLevel > 0) {
    <div class="tree-node-horizontal-connector"></div>
  }

  <div class="tree-node-name">{{ item.data.name }}</div>

  <div class="tree-node-amount">
    @if (editing()) {
      <input #amountInput inputmode="decimal" [value]="formatAmountInput(item.data.amount)" (keyup.enter)="save(amountInput.value)" (keyup.escape)="stopEditing()" (blur)="stopEditing()"> {{ item.data.unit }}
    } @else {
      {{ formatAmount(item.data.amount, item.data.unit) }}
    }
  </div>
</div>

<div class="tree-node-children">
  @for (child of item.children; track child.id) {
    <client-order-tree-node [item]="child" [depthLevel]="depthLevel + 1" [frozen]="frozen"></client-order-tree-node>
  }
</div>
